import { ElementRef } from '@angular/core';

export class TabNavigationUtils {
  static handleTabNavigation(
    event: KeyboardEvent,
    elementRef: ElementRef,
    focusTab: (focusable: HTMLElement[], event: KeyboardEvent) => void
  ): void {
    const focusable = this.getFocusableElements(elementRef);
    if (focusable) {
      focusTab(focusable, event);
    }
  }

  static getFocusableElements(elementRef: ElementRef): HTMLElement[] | null {
    const focusable = elementRef.nativeElement
      .querySelector('#profile-selector-smart')
      ?.querySelectorAll(
        'input,button,select,textarea,a,[tabindex]:not([tabindex="-1"])'
      );

    return focusable?.length ? (Array.from(focusable) as HTMLElement[]) : null;
  }
}
